// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/Content/IdeasLabView.js
import React, { useState } from 'react'; // เอา useEffect ออกถ้าไม่ได้ใช้ในนี้แล้ว
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import ToastNotification from '../ToastNotification';
import IdeasLabForm from './IdeasLabForm'; // ยังคงใช้ Form
import '../../css/InternetHeaderView.scss';
import { deleteIdeasLab } from '../../utils/ExploreIdeasLabHandlers'; // Import เฉพาะ delete ถ้า Add/Update ทำผ่าน Form นอก View นี้

const IdeasLabView = ({
  headers,
  // setHeaders, // ไม่รับมาแล้ว ใช้ refreshData แทน
  totalCount,
  // searchQuery,
  pageLength,
  currentPage, // รับมาเพื่อแสดงผล และคำนวณ 'first'
  // setCurrentPage, // ไม่รับมาแล้ว
  handlePageLengthChange,
  refreshData, // รับ function refresh จาก parent
  onPageSelect, // *** รับ handler ใหม่จาก Parent ***
  // handleDelete, // รับ handler การลบจาก Parent (ถ้าต้องการให้ปุ่มลบเรียก handler ของ Parent)
}) => {
  // State ภายในสำหรับ UI ของ View นี้เท่านั้น
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const [showForm, setShowForm] = useState(false);
  const [formMode, setFormMode] = useState('add');
  const [selectedIdea, setSelectedIdea] = useState(null);

  // คำนวณ 'first' สำหรับ DataTable (จำเป็นสำหรับ lazy loading)
  const first = (currentPage - 1) * pageLength;

  const showToastMessage = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);
  };

  // Editor สำหรับ inline edit (ถ้ายังต้องการ)
  const textEditor = (options) => (
    <InputText
      type="text"
      value={options.value || ''}
      onChange={(e) => options.editorCallback(e.target.value)}
      style={{ width: '100%' }}
    />
  );

  // Handler เมื่อกดปุ่ม Edit (ดินสอ) -> เปิด Form แยก
  const onRowEditInit = (e) => {
    setFormMode('edit');
    setSelectedIdea(e.data);
    setShowForm(true); // เปิด Form ที่จัดการโดย Parent หรือ State ในนี้ก็ได้ (ตอนนี้จัดการในนี้)
  };

  // Template ปุ่มลบ
  const deleteActionTemplate = (rowData) => (
    <Button
      icon="pi pi-trash"
      className="p-button-danger p-button-sm"
      onClick={async () => {
        const confirmDelete = window.confirm(`Are you sure you want to delete Idea ID: ${rowData.Home_ID}?`);
        if (confirmDelete) {
            try {
                await deleteIdeasLab(rowData.Home_ID); // เรียก API delete โดยตรง
                showToastMessage('Idea deleted successfully', 'success');
                refreshData(); // *** บอกให้ Parent โหลดข้อมูลใหม่ ***
            } catch (err) {
                showToastMessage(`Error deleting idea: ${err.message}`, 'error');
            }
        }
      }}
    />
  );

  // Handler ปุ่ม Add Idea -> เปิด Form
  const addIdea = () => {
    setFormMode('add');
    setSelectedIdea(null);
    setShowForm(true);
  };

  // Handler เมื่อ Form (ที่แสดงใน View นี้) ถูก Save
  const handleFormSave = (savedIdea) => {
    // ไม่ต้องทำอะไรกับ headers ที่นี่ เพราะ Parent จะ refresh
    setShowForm(false);
    showToastMessage(`Idea ${formMode === 'add' ? 'added' : 'updated'} successfully`, 'success');
    refreshData(); // *** บอกให้ Parent โหลดข้อมูลใหม่ ***
  };

  // Handler เมื่อ Form (ที่แสดงใน View นี้) ถูก Cancel
  const handleFormCancel = () => {
    setShowForm(false);
    setSelectedIdea(null);
  };

  // Handler สำหรับ PrimeReact DataTable's onPage event
  const onPageChange = (event) => {
    // event.page คือ 0-based index ของหน้าที่เลือก
    // event.rows คือ pageLength
    // event.first คือ index ของ record แรก
    console.log("DataTable Page Event:", event);
    const newPage = event.page + 1; // แปลงเป็น 1-based index
    if (newPage !== currentPage) {
        onPageSelect(newPage); // *** เรียก handler ของ Parent ***
    }
  };

  // Template แสดง Category (เหมือนเดิม)
  const categoryTemplate = (rowData) => {
    if (Number(rowData.Home_Category) === 1) {
      return `Ideas Lab | ${rowData.Home_Category}`;
    }
    return rowData.Home_Category;
  };

  // ไม่จำเป็นต้องคำนวณ totalPages เอง DataTable จัดการให้
  // const totalPages = Math.ceil(totalCount / pageLength);

  return (
    <>
      <ToastNotification
        showToast={showToast}
        toastMessage={toastMessage}
        toastVariant={toastVariant}
        setShowToast={setShowToast}
      />

      {/* Form แสดง/ซ่อน ตาม State ใน View นี้ */}
      {showForm && (
        <IdeasLabForm
          ideaData={selectedIdea}
          mode={formMode}
          onCancel={handleFormCancel}
          onSave={handleFormSave} // ใช้ handler ที่เรียก refreshData()
        />
      )}

      {/* ตารางแสดงเมื่อไม่ได้เปิด Form */}
      {!showForm && (
        <div className="ideaslab-header-wrapper">
          <div className="d-grid gap-2 d-md-flex justify-content-md-end mb-2">
            <Button
              icon="pi pi-plus"
              label="Add Idea"
              className="p-button-success p-button-sm"
              onClick={addIdea} // เปิด Form ใน View นี้
            />
            <div className="select-container me-md-2">
              <select
                id="pageLengthSelect"
                className="form-select form-select-sm" // ใช้ form-select-sm
                value={pageLength}
                onChange={handlePageLengthChange} // ใช้ Handler จาก Parent
                style={{ width: 'auto' }}
              >
                <option value="10">10 Rows</option>
                <option value="20">20 Rows</option>
                <option value="50">50 Rows</option>
                <option value="100">100 Rows</option> {/* เพิ่ม 100 */}
              </select>
            </div>
          </div>

          <DataTable
            value={headers} // ข้อมูลจาก Parent
            paginator // เปิด Paginator ของ PrimeReact
            rows={pageLength} // จำนวนแถวต่อหน้า (จาก Parent)
            totalRecords={totalCount} // จำนวนทั้งหมด (จาก Parent)
            lazy // *** เปิด Lazy Loading ***
            first={first} // Index แรกของหน้าปัจจุบัน (คำนวณจาก currentPage)
            onPage={onPageChange} // *** ใช้ onPage handler ของ DataTable ***
            editMode="row"
            dataKey="Home_ID"
            onRowEditInit={onRowEditInit} // Handler เปิด Form Edit
            className="p-datatable-gridlines"
            // --- ใช้ Paginator Template มาตรฐาน ---
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            rowsPerPageOptions={[10, 20, 50, 100]} // ตัวเลือกจำนวนแถว (ควรตรงกับ select ด้านบน)
            // loading={isLoading} // สามารถรับ isLoading จาก Parent มาแสดงได้
          >
            {/* Columns เหมือนเดิม */}
            <Column field="Home_ID" header="ID" style={{ width: '8%' }} sortable />
            <Column
              field="Home_Category"
              header="Category"
              style={{ width: '15%' }}
              body={categoryTemplate}
              // editor={textEditor} // ไม่ควร edit category ตรงๆ
              sortable
            />
            <Column field="Home_Visitors" header="Visitors" style={{ width: '10%' }} sortable />
            <Column
              field="Home_Sub"
              header="Subject"
              style={{ width: '42%' }}
              // editor={textEditor} // ควรแก้ผ่าน Form
              sortable
            />
            <Column
               rowEditor // ใช้ component rowEditor ของ PrimeReact สำหรับปุ่ม Edit/Cancel ในแถว
               header="Edit"
               style={{ width: '10%', textAlign: 'center' }}
               bodyStyle={{ textAlign: 'center' }}
               // onRowEditInit จะถูกเรียกเมื่อกดดินสอ
             />
            <Column
              header="Delete"
              body={deleteActionTemplate} // ใช้ template ปุ่มลบ
              style={{ width: '10%', textAlign: 'center' }}
              bodyStyle={{ textAlign: 'center' }}
            />
          </DataTable>
        </div>
      )}
    </>
  );
};

export default IdeasLabView;